import { render, staticRenderFns } from "./EmployeeDetails.vue?vue&type=template&id=17867cda&"
import script from "./EmployeeDetails.vue?vue&type=script&lang=js&"
export * from "./EmployeeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17867cda')) {
      api.createRecord('17867cda', component.options)
    } else {
      api.reload('17867cda', component.options)
    }
    module.hot.accept("./EmployeeDetails.vue?vue&type=template&id=17867cda&", function () {
      api.rerender('17867cda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hrmanagement/EmployeeManagement/EmployeeDetails/EmployeeDetails.vue"
export default component.exports